const { baseRoutes } = require("helpers/baseRoutes");

const accessRoute = {
  FAMILY_TREE: {
    path: `${baseRoutes.userBaseRoutes}family-tree`,
  },
};

export default accessRoute;
